module.exports = __webpack_public_path__ + "img/寒热状态.5a254028.png";